export enum AppRoutes {
  HOME = 'home',
  SHOP_MANAGEMENT = 'shop-management',
}
